var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasExistingWorkplan)?_c('review-workplan-empty-state',{on:{"review-workplan":_vm.onReviewWorkplan}}):_c('generate-workplan-empty-state',{attrs:{"resource-id":_vm.resourceId,"work-item-web-url":_vm.workItemWebUrl},on:{"generate-workplan":_vm.onGenerateWorkplan}})
}
var staticRenderFns = []

export { render, staticRenderFns }